import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class zipdownloadService {
  baseUrl: string = environment.cloudUrl;
  listUrl: string = this.baseUrl + 'import/order?orderId';
  //   http://localhost:8080/api/v1/import/order?orderId=DC000005
  constructor(private http: HttpClient) {}
  getfile(id): Observable<any> {
    const url = `${this.listUrl}=${id}`;
    return this.http.get(url).pipe(
      map((data) => {
        return data;
      })
    );
  }
}
